/**
 * CL-INVOICE-001B2-V1 — Existing portal accounts with emailVerified=false (grandfathered access).
 */

import { classifyPortalEmailVerificationRolloutFromUser } from "./portalEmailVerificationRolloutPolicy";

export const EXISTING_ACCOUNT_VERIFICATION_BANNER_COPY = Object.freeze({
  title: "Verify your email address",
  lead:
    "Some portal actions, including viewing invoices, require a verified email address on your account.",
  expiredLink:
    "If your verification link expired or no longer works, send a fresh verification email below.",
  sendSuccess: "Verification email sent. Check your inbox and spam folder, then use I've verified my email.",
  notVerifiedYet:
    "Your email is not verified yet. Open the link in your inbox first, then select I've verified my email.",
  verifiedSuccess: "Email verified. Thank you — this reminder will disappear on your next page load.",
});

export function shouldShowExistingAccountEmailVerificationBanner(user = null) {
  if (!user || user.isAnonymous || user.emailVerified === true) return false;
  const classification = classifyPortalEmailVerificationRolloutFromUser(user);
  return classification.allowPortalAccess === true && classification.showVerificationPanel !== true;
}
